<template>
  <div>
    <SlideTransition>
      <div :style="maxHeightContainerStyle" class="relative">
        <div ref="maxHeightContainer">
          <slot></slot>
        </div>
        <div
          class="absolute bottom-0 left-0 right-0 w-full h-16 white-gradient"
          v-if="canShowMore && !this.isOpen"
        ></div>
      </div>
    </SlideTransition>

    <div class="mt-6">
      <a
        href="#"
        @click.prevent="showMore"
        v-if="canShowMore && !this.isOpen"
        class="font-medium text-blue-300 ds-text-base"
      >Show more</a>
      <a
        href="#"
        @click.prevent="showLess"
        v-if="canShowMore && this.isOpen"
        class="font-medium text-blue-300 ds-text-base"
      >Show less</a>
    </div>
  </div>
</template>

<script>
import { SlideTransition } from '@sportsrecruits/playbook';

export default {
  components: {
    SlideTransition
  },
  props: {
    maxHeight: { type: Number, required: true }
  },
  data() {
    return {
      innerContentHeight: 0,
      isOpen: false
    };
  },
  mounted() {
    this.updateHeight();

    window.addEventListener("resize", this.updateHeight);
  },
  updated() {
    this.updateHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHeight);
  },
  computed: {
    maxHeightContainerStyle: function() {
      return {
        maxHeight: this.isOpen ? "initial" : `${this.maxHeight}px`,
        overflowY: "hidden"
      };
    },
    canShowMore: function() {
      return this.innerContentHeight > this.maxHeight;
    }
  },
  methods: {
    showMore() {
      this.isOpen = true;
    },
    showLess() {
      this.isOpen = false;
    },
    updateHeight() {
      /**
       * Hacky hack hack
       */
      if (this.$refs.maxHeightContainer.offsetHeight === 0) {
        setTimeout(() => {
          this.updateHeight()
        }, 500);
      } else {
        this.innerContentHeight = this.$refs.maxHeightContainer.offsetHeight;
      }
    }
  }
};
</script>

<style scoped>
.white-gradient {
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}
</style>